module.exports = __webpack_public_path__ + "img/11.335d0419.png";